// ============================================================
//  MASAMADREAM — Toast notifications
// ============================================================

const DURATION = 3000; // ms

export function toast(message, duration = DURATION) {
  const container = document.getElementById('mm-toast-container');
  if (!container) return;

  const el = document.createElement('div');
  el.className = 'mm-toast';
  el.textContent = message;
  container.appendChild(el);

  setTimeout(() => {
    el.classList.add('is-hiding');
    el.addEventListener('animationend', () => el.remove(), { once: true });
  }, duration);
}
